const REGEX = /(\w+)="([^"]*)"/g;

export default function extractAttributes(html: string): Record<string, string> {
  // Regular expression to match attributes in the format key="value"
  let match;
  const attributes: Record<string, string> = {};

  // Iterate over all matches
  while ((match = REGEX.exec(html)) !== null) {
    const key = match[1].toLowerCase(); // Attribute name
    const value = match[2]; // Attribute value
    attributes[key] = value;
  }

  return attributes;
}
